import { C8AttributeId, C8NodeType } from "src/c8-platform/type/node";
import ReflectionAttribute from "./ReflectionAttribute";
import ReflectionClass from "./ReflectionClass";
import ReflectionDomainClass from "./ReflectionDomainClass";
import { getClassAttribute, getDomainClass } from "./reflectionData";
import { DomainRelationData, IReflectionDomainAttribute } from "./reflectionTypes";

export default class ReflectionDomainRelation implements IReflectionDomainAttribute {
	readonly domainId: C8AttributeId;
	readonly rca: ReflectionAttribute;
	readonly secondaryId: C8AttributeId;

	_definition: DomainRelationData;

	destinations: ReflectionDomainClass[];

	constructor(data: DomainRelationData, primaryClass: ReflectionClass, secondaryMap: Record<string, ReflectionClass>) {
		const [domainId, , secondaryId, reflectionId] = data;
		const owner = secondaryMap[secondaryId] || primaryClass;
		const rca = getClassAttribute(owner, reflectionId || domainId);

		this.domainId = domainId;
		this.rca = rca;
		this.secondaryId = secondaryId;

		// store domain attribute id on reflection attribute
		if (rca && reflectionId) {
			rca.domainAttributeIds[owner.type] = domainId;
		}

		// temporary member to hold input till initRelationDestinations() call
		this._definition = data;
	}

	/**
	 * Returns destination type for Domain Relation with given id. If there is more than one destination then return undefined.
	 */
	getSingleDestinationType = (): C8NodeType | undefined => {
		if (this.destinations.length === 1) {
			return this.destinations[0].type;
		}
	};

	initRelationDestinations(): void {
		// there are just a few cases where destinations will be empty which just means the relationship should never be populated;
		// this occurs when something like the following is found in Navigation.xml:
		//	<Source Class="SupplierCrew">
		//		<Target Class="" />
		//	</Source>
		console.assert(!!this._definition);
		this.destinations = this._definition[1]?.map(getDomainClass) || [];
		delete this._definition;
	}
}